import { Component, Input } from '@angular/core';
import { SectionType, SummaryFormSections, SummarySectionApplicant, SummarySectionElements, SummarySectionOrganization } from 'src/app/interfaces/form-model';

@Component({
  selector: 'app-summary-membership-section',
  templateUrl: './summary-membership-section.component.html',
  styleUrls: ['./summary-membership-section.component.scss']
})
export class SummaryMembershipSectionComponent {

  @Input() section!: SummaryFormSections;

  categorizeElement(element: any): string {

    if (element?.priceField) {
      return 'priceField';
    }

    if (element?.type === 150) {
      return 'addressField';
    }

    const fileFieldTypes = [7, 8, 206, 207, 405, "image", "file"];
    if (fileFieldTypes.includes(element?.type)) {
      return 'fileField';
    }

    const selectFieldTypes = [4, 6, 5, 203, 204, 205, 344, 345, 404];
    if (selectFieldTypes.includes(element?.type)) {
      return 'selectField';
    }

    return 'simpleText';
  }

  getGeneralElement(element: SummarySectionElements) {

    element.adminOverride = this.section.adminOverride;
    element.callback = this.section.callback;
    element.sectionType = SectionType.REGULAR;

    return element;
  }

  getOrganizationElement(element: SummarySectionElements): any {

    element.adminOverride = false;

    return element;
  }

  getApplicantElement(applicant: SummarySectionApplicant, element: SummarySectionElements): any {

    element.adminOverride = this.section.adminOverride;
    element.callback = this.section.callback;
    element.applicantId = applicant.id;
    element.sectionType = SectionType.APPLICANT;

    return element;
  }
}
